export enum TireImagePosition {
    LEFT = "left",
    RIGHT = "right",
}